exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-title[data-v-f49b873e]{font-weight:800}.btn[data-v-f49b873e]{margin:10px;padding:0 16px}.small[data-v-f49b873e]{font-size:13px}.smaller[data-v-f49b873e]{font-size:12px}.middle[data-v-f49b873e]{padding:3px 6px 3px 3px}.grey-color[data-v-f49b873e]{color:#8a8a8a}.date-picker[data-v-f49b873e] .date-picker-calendar{width:100%;height:330px}.date-picker[data-v-f49b873e] .date-picker-calendar .selected,.date-picker[data-v-f49b873e] .date-picker-calendar .selected:hover{background-color:var(--selected-bg-color);color:var(--selected-color)}.date-picker[data-v-f49b873e] .date-picker-calendar .today{border:1px solid var(--selected-border-color)}.save-reservation-title[data-v-f49b873e]{font-weight:800;font-size:18px}.save-reservation-text[data-v-f49b873e]{font-size:13px;color:#8a8a8a;margin-top:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f49b873e","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/reservations.vue
// module id = AeTD
// module chunks = 0